import { SAINT_QUOTATIONS } from "@/data/saintQuotations";
import { PRAYERS as CATALOGUE } from "@/data/prayers";
import { scriptureQuote } from "@/data/scripture";

export const IMAGES = {
  hero: {
    url: "https://commons.wikimedia.org/wiki/Special:FilePath/La%20Vierge%20aux%20anges-William%20Bouguereau.jpg?width=1024",
    alt: "William-Adolphe Bouguereau, The Virgin with Angels (1900)",
    credit: "W.-A. Bouguereau, The Virgin with Angels, 1900 · Petit Palais, Paris · Public domain",
  },
  murillo: {
    url: "https://commons.wikimedia.org/wiki/Special:FilePath/Murillo%20-%20Inmaculada%20Concepci%C3%B3n%20de%20los%20Venerables%20o%20de%20Soult%20(Museo%20del%20Prado%2C%201678).jpg?width=800",
    alt: "Bartolomé Esteban Murillo, The Immaculate Conception of Los Venerables (1678)",
    credit: "B. E. Murillo, Immaculate Conception of Los Venerables, 1678 · Museo del Prado · Public domain",
  },
  stainedGlass: {
    url: "https://images.unsplash.com/photo-1546444809-d64eccd9fb88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    alt: "Luminous stained-glass window inside a Catholic cathedral",
  },
  altar: {
    url: "https://images.unsplash.com/photo-1580915469718-20aac389d0a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "A quiet sanctuary altar lit by stained glass",
  },
};


export const DOGMAS = [
  {
    title: "Mother of God — Theotokos",
    seal: "Council of Ephesus, 431",
    text: "Because the one she bore is truly God the Son made man, the Church confesses Mary as Theotokos — the God-bearer, Mother of God. Every Marian truth begins here: her motherhood is about who Jesus is.",
  },
  {
    title: "Perpetual Virginity",
    seal: "Confessed by the early Councils; Lateran Council, 649",
    text: "The Church has always professed that Mary remained a virgin before, during, and after the birth of Christ — a sign of her complete and undivided gift of self to the Father’s plan.",
  },
  {
    title: "The Immaculate Conception",
    seal: "Defined by Bl. Pius IX, 1854",
    text: "From the first instant of her conception, Mary was preserved from original sin by the merits of her Son — “full of grace,” prepared to be a worthy dwelling for the Word made flesh. It was this title she confirmed at Lourdes in 1858.",
  },
  {
    title: "The Assumption",
    seal: "Defined by Ven. Pius XII, 1950",
    text: "At the end of her earthly life, Mary was taken body and soul into heavenly glory — the first-fruits of the resurrection promised to all who belong to Christ, and a sign of hope for the pilgrim Church.",
  },
];

export const PRAYERS = ["hail-mary", "memorare", "salve-regina", "regina-caeli", "angelus", "loreto"].map((id) => CATALOGUE.find((p) => p.id === id)).concat(CATALOGUE.filter((p) => p.cat === "fatima" && !p.externalOnly)).map((p) => ({ ...p, text: p.lines.find(([lang]) => lang === "English")?.[1] || "" }));


export const SCRIPTURES = [
  { ref: "Luke 1:28", text: "“Greetings, favored one! The Lord is with you.”" },
  { ref: "John 2:5", text: "“Do whatever he tells you.”" },
  { ref: "Luke 1:46–47", text: "“My soul magnifies the Lord, and my spirit rejoices in God my Savior,”" },
  { ref: "John 19:26–27", text: "“Woman, here is your son.” … “Here is your mother.”" },
  { ref: "Revelation 12:1", text: "“a woman clothed with the sun, with the moon under her feet,”" },
  { ref: "Luke 1:42", text: "“Blessed are you among women, and blessed is the fruit of your womb.”" },
  { ref: "Genesis 3:15", text: "“he will strike your head, and you will strike his heel.”" },
].map((verse) => ({ ...scriptureQuote(verse.ref), source: `${verse.ref} · RSV-CE` }));

export const SAINT_QUOTES = ["montfort", "bernard", "jp2", "teresa", "kolbe"].map((id) => {
  const quote = SAINT_QUOTATIONS[id];
  return { ...quote, text: quote.kind === "paraphrase" ? quote.text : `“${quote.text}”` };
});

export const MARQUEE_TITLES = [
  "Mater Ecclesiae",
  "Regina Caeli",
  "Stella Maris",
  "Salve Regina",
  "Mater Dolorosa",
  "Auxilium Christianorum",
  "Rosa Mystica",
  "Domus Aurea",
  "Turris Davidica",
  "Regina Pacis",
  "Janua Caeli",
  "Refugium Peccatorum",
];

export const MYSTERY_SETS = {
  0: { name: "Glorious Mysteries", list: ["The Resurrection", "The Ascension", "The Descent of the Holy Spirit", "The Assumption of Mary", "The Coronation of Mary"] },
  1: { name: "Joyful Mysteries", list: ["The Annunciation", "The Visitation", "The Nativity", "The Presentation", "The Finding in the Temple"] },
  2: { name: "Sorrowful Mysteries", list: ["The Agony in the Garden", "The Scourging at the Pillar", "The Crowning with Thorns", "The Carrying of the Cross", "The Crucifixion"] },
  3: { name: "Glorious Mysteries", list: ["The Resurrection", "The Ascension", "The Descent of the Holy Spirit", "The Assumption of Mary", "The Coronation of Mary"] },
  4: { name: "Luminous Mysteries", list: ["The Baptism in the Jordan", "The Wedding at Cana", "The Proclamation of the Kingdom", "The Transfiguration", "The Institution of the Eucharist"] },
  5: { name: "Sorrowful Mysteries", list: ["The Agony in the Garden", "The Scourging at the Pillar", "The Crowning with Thorns", "The Carrying of the Cross", "The Crucifixion"] },
  6: { name: "Joyful Mysteries", list: ["The Annunciation", "The Visitation", "The Nativity", "The Presentation", "The Finding in the Temple"] },
};
